<template>
  <div class="vn-header">
    <img v-if="id === 'patientInfo'" src="../../assets/heart.svg" />
    <img v-else src="../../assets/med-cross.svg" />
    <v-card-title class="card-title">
      {{ title }}
    </v-card-title>
    <v-btn @click="toggleDialog" class="btn" color="primary" text small>
      {{ $t("visits.summary.clearAll") }}
    </v-btn>
    <Confirm
      :dialog="dialog"
      :title="$t('visits.summary.clearAllTitle')"
      :text="$t('visits.summary.clearAllText')"
      :confirmText="$t('visits.summary.clearAllConfirm')"
      :cancelText="$t('general.dialog.cancel')"
      @toggleDialog="toggleDialog"
      @confirm="clearAll"
    />
  </div>
</template>

<script>
import Confirm from "../shared/Confirm.vue";
export default {
  name: "VisitNotesCardHeader",
  components: {
    Confirm,
  },
  props: {
    title: String,
    id: String,
  },
  data: () => ({
    dialog: false,
  }),
  methods: {
    clearAll() {
      this.$emit("clear");
      this.toggleDialog();
    },
    toggleDialog() {
      this.dialog = !this.dialog;
    },
  },
};
</script>

<style lang="scss" scoped>
.vn-header {
  display: flex;
  align-items: center;
  margin-bottom: 28px;
}
.btn {
  display: inline-block;
  text-transform: capitalize;
  font-weight: 600;
}
.blue {
  color: #1aa7e8;
}
.card-title {
  word-break: initial;
}
</style>
